import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';

const HERO_IMG =
  'https://customer-assets.emergentagent.com/job_dj-alfredj/artifacts/qj2sku4c_alfredj4.jpeg';

export const Hero = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden">
      {/* Foto de Alfredj en acción (reemplazable) */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Alfredj pinchando en directo"
          loading="eager"
          className="w-full h-full object-cover object-center opacity-90 saturate-[0.85]"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
      </div>

      {/* Título gigante de fondo (decorativo) */}
      <span
        aria-hidden
        className="pointer-events-none select-none absolute top-[18%] left-0 right-0 text-center font-heading text-[26vw] leading-none text-stroke opacity-40"
      >
        ALFREDJ
      </span>

      <div className="relative z-10 mx-auto max-w-7xl w-full px-5 sm:px-8 pb-16 sm:pb-24">
        <motion.div
          initial="hidden"
          animate="show"
          variants={{ show: { transition: { staggerChildren: 0.12 } } }}
          className="max-w-4xl"
        >
          <motion.p
            variants={{ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } }}
            className="text-acid uppercase tracking-[0.3em] text-xs sm:text-sm mb-4 font-medium"
          >
            DJ · Selector musical · Albacete
          </motion.p>

          <motion.h1
            variants={{ hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0 } }}
            className="font-heading uppercase text-5xl sm:text-7xl lg:text-8xl leading-[0.9] tracking-tightest text-[#f1f0ea]"
          >
            30 años pinchando la <span className="text-acid">banda sonora</span> de tus mejores momentos
          </motion.h1>

          <motion.p
            variants={{ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } }}
            className="mt-6 text-base sm:text-lg text-[#f1f0ea]/80 max-w-2xl font-light"
          >
            Especialista en música independiente: indie-rock, indie-pop, britpop y clásicos
            alternativos. No pongo la lista de la radio, creo una atmósfera única.
          </motion.p>

          <motion.div
            variants={{ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } }}
            className="mt-9 flex flex-col sm:flex-row gap-4"
          >
            <button
              data-testid="hero-cta-primary"
              onClick={() => go('#contacto')}
              className="bg-acid text-white font-heading uppercase text-lg sm:text-xl px-8 py-4 hover:-translate-y-1 hover:shadow-[5px_5px_0px_#f1f0ea] transition-all duration-200"
            >
              Reservar Fecha / Pedir Presupuesto
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => go('#sesiones')}
              className="border border-white/25 text-[#f1f0ea] font-heading uppercase text-lg sm:text-xl px-8 py-4 hover:border-acid hover:text-acid transition-colors duration-200"
            >
              Escuchar sesiones
            </button>
          </motion.div>
        </motion.div>
      </div>

      <button
        onClick={() => go('#sobre')}
        className="absolute bottom-6 right-6 z-10 hidden sm:flex items-center gap-2 text-[#f1f0ea]/60 hover:text-acid transition-colors"
        data-testid="hero-scroll-down"
      >
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <ArrowDown size={18} className="animate-bounce" />
      </button>
    </section>
  );
};
